<template>
  <PopperTooltip v-if="CUSTOMER">
    <template #button>
      <p class="m-0" v-if="CUSTOMER.vecdsrso">
        {{ CUSTOMER.vecdsrso }}
      </p>
      <small class="m-0" v-if="CUSTOMER.DESvecdsrso">
        {{ CUSTOMER.DESvecdsrso }}
      </small>
    </template>
    <template #tooltip>
      <!-- cliente -->
      <p class="mb-1">#{{ CUSTOMER.veccdclf }}</p>
      <div v-if="CUSTOMER?.veccdclf" class="mb-2">
        <p class="tooltip-subtitle m-0">Cliente</p>
        <h6 class="m-0" v-if="CUSTOMER.vecdsrso">
          {{ CUSTOMER.vecdsrso }}
        </h6>
        <p v-if="CUSTOMER.indirizzo">
          <small>
            {{ CUSTOMER.indirizzo }}
          </small>
        </p>
      </div>

      <div v-if="CUSTOMER?.DESvecdsrso" class="mb-2">
        <p class="tooltip-subtitle m-0">Destinazione</p>
        <h6 class="m-0" v-if="CUSTOMER.DESvecdsrso">
          {{ CUSTOMER.DESvecdsrso }}
        </h6>
        <p v-if="CUSTOMER.indirizzoDestinazione">
          <small>
            {{ CUSTOMER.indirizzoDestinazione }}
          </small>
        </p>
        <p v-if="CUSTOMER.DESvecdschiusura">
          <small>{{ CUSTOMER.DESvecdschiusura }}</small>
        </p>
      </div>

      <b-button variant="primary" size="sm" :to="{ name: 'ClientiRicerca' }"> Cambia cliente </b-button>
    </template>
  </PopperTooltip>
</template>
<style scoped>
.tooltip-subtitle {
  color: var(--bs-dark);
}
</style>
<script lang="ts">
import { useCustomerStore } from "@/stores/customers";
import { computed } from "vue";
import PopperTooltip from "@/components/PopperTooltip.vue";

export default {
  components: { PopperTooltip },
  setup() {
    const data = {};
    const methods = {};
    const customerStore = useCustomerStore();
    const computed_ = {
      CUSTOMER: computed(() => customerStore.CUSTOMERS_getCurrent),
    };
    return {
      ...data,
      ...methods,
      ...computed_,
    };
  },
};
</script>
